import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FormCoreModule } from '../form-core.module';

@Injectable({
  providedIn: FormCoreModule
})
export class DestroyService {

  destroy$: Subject<any> = new Subject()

  constructor() { }

  destroy() {
    this.destroy$.next('')
    this.destroy$.complete()
  }
}
